const es = {
  copyRight: " ",
  home: "Inicio",
  examination: "examen",
  course: "curso",
  record: "registro",
  help: "ayuda",
  register: "registro",
  login: "Iniciar sesión",
  login2: "empleado",
  usernamePasswordLogin: "Nombre de usuario",
  search: "buscar",
  reset: "restablecer",
  username: "Nombre de usuario",
  technicalLiterature: "Literatura técnica",
  personalcollect: "Recogida de datos personales",
  usernameOrEmail: "Nombre de usuario o correo electrónico",
  password: "contraseña",
  oldPassword: "Contraseña antigua",
  newPassword: "Nueva contraseña",
  confirm: "Confirmar confirmación",
  sure: "Confirmar confirmación",
  cancel: "cancelar",
  tips: "consejos",
  save: "guardar",
  submit: "enviar",
  confirmSubmit: "Confirmar el envío?",
  tenantCode: "TenantCode",
  email: "Correo electrónico",
  validationCode: "Código de validación",
  inputValidationCode: "Código de validación de entrada",
  forgetPassword: "¿Ha olvidado la contraseña?",
  updatePasswords: "Cambiar mi contraseña",
  dateOfBirth: "Fecha de nacimiento",
  smsCodeLogin: "Código Sms login",
  phoneNumber: "Número de teléfono",
  sendValidationCode: "Enviar código de validación",
  send: "enviar",
  cutdown: "Readquisien {count}s",
  sendSuccess: "Enviar el éxito",
  registerSuccess: "Registro de éxito",
  success: "éxito",
  successAndExit: "Página de éxito está a punto de cerrar automáticamente",
  failed: "fracaso",
  operation: "funcionamiento",
  return: "retorno",
  load: {
    loadMore: "Carga más",
    loadFailed: "¡Fallo de carga!",
    noMoreData: "No más datos!",
    loading: "Cargando..."
  },
  validate: {
    inputUsername: "Introduzca el nombre de usuarioPlease input username",
    inputEmail: "Por favor escriba el correo electrónico",
    inputPassword: "Por favor introduzca la contraseña",
    inputValidationCode: "Por favor introduzca el código de validación",
    inputPhoneNumber: "Por favor introduzca el número de teléfono",
    usernameExists: "Existe un nombre de usuario",
    inputPhoneLen: "Por favor introduzca el número de teléfono de once longitudes",
    passwordMustFourLength: "Introduzca al menos una contraseña de cuatro longitudes",
    validationCodeMustFourLength:
      "Por favor introduzca al menos cuatro códigos de validación de longitud"
  },
  language: {
    zh: "中文",
    en: "English"
  },
  common: {
    link: "enlace",
    tool: "El instrumento",
    community: "comunidad",
    gitee: "",
    github: "",
    admin: "administración",
    changeLog: "Changelog (en inglés).",
    feedback: "retroalimentación",
    legalNotices: "Aviso Legal",
    legalNoticesContent:
      "Esto es sólo para la práctica personal proyecto de imitación de código abierto para el aprendizaje de referencia sólo y no puede soportar ninguna cuestión legal",
    privacyPolicy: "Política de privacidad",
    privacyPolicyContent:
      "Este sitio web no cumplirá estrictamente con las leyes y reglamentos pertinentes y el contenido establecido en esta política de privacidad para recopilar y utilizar su información",
    developerCenter: "Centro de desarrollo"
  },
  header: {
    sourceCode: "Código fuente",
    document: "Documento",
    changeLog: "ChangeLog (en inglés).",
    roadmap: "Hoja de ruta",
    admin: "administración",
    personal: 'Certificate',
    changePwd: "Cambiar la contraseña",
    logout: "Cerrar sesión",
    certPrompt: 'Puedes consultar tu certificado aquí.',
  },
  homePage: {
    startUsing: "Empezar a usar",
    userCnt: "Usuario usuario",
    examinationCnt: "exámenes",
    subjectCnt: "tema",
    courseCnt: "curso",
    popularCourses: "Cursos populares",
    loadFailed: "¡Fallo de carga!",
    loadCoursesFailed: "¡Los cursos populares de carga fallaron!"
  },
  exam: {
    examinationName: "Nombre del examen",
    examinationType: "Typetipo",
    examinationTime: "Tiempo tiempo",
    status: "Estado de la situación",
    score: "La puntuación",
    scoreDetail: "detalle",
    scoreRank: "rango",
    course: {
      courseName: "Nombre del curso",
      courseIntroduction: "Introducción al curso",
      chapter: "Capítulo capítulo",
      courseEvaluation: "evaluación",
      inputEvaluation: "Introduzca el contenido de la evaluación",
      studyExchange: "Intercambio de estudios",
      courseAttach: "El apego",
      registerStudents: "Registro de estudiantes",
      registerStudents1: "Estudiantes registrados",
      examination: "examen",
      examinations: "examen",
      courseFeatures: "Características del curso",
      learnHour: "Hora de aprendizaje",
      chapter1: "Capítulo capítulo",
      memberCount: "Número de estudiantes",
      evaluatesCount: "Evalúa el conteo",
      youMayAlsoLike: "Supongo que te gusta",
      hour: "hora",
      charge: "cargo",
      free: "libre",
      atOnce: "Aprender",
      registration: "registro",
      cancelRegistration: "Cancelación del registro",
      pleaseRegistration: "Por favor, registrarse",
      startLearn: "Aprender",
      submitSuccess: "Presentar el éxito",
      submitFailed: "No presentado",
      doNotResubmit: "",
      doReqexam: 'Por favor, realice el examen del curso de formación',
      defaultEvaluate: "Comentarios positivos por defecto del usuario",
      demoCourseName: "La escritura",
      courses: {
        popularCourses: "Cursos populares",
        registerStudentsCnt: "Vistas",
        level: "Nivel de dificultad"
      }
    },
    records: {
      records: "Registros"
    },
    exams: {
      examRemark: "Introducción",
      examAttention: "La atención",
      examTime: "Tiempo de examen",
      unLimitTime: "Sin límite",
      all: "Todos",
      latestRelease: "La última versión",
      mostClicks: "La mayoría de los clic",
      parameters: "Parámetros",
      end: "El examen ha terminado",
      notStarted: "El examen no comenzó",
      start: "Comienzo",
      sureStart: "¿Estás seguro de que quieres empezar?",
      evaluation: "evaluación",
      startFailed: "Inicio fal",
      inputEvaluation: "Por favor ingresu evaluación",
      submitSuccess: "Enviar con éxito",
      doNotResubmit: "No volver a enviar",
      defaultEvaluate: "Comentarios positivos por defecto del usuario",
      examResult: 'Resultado del examen',
      ok: 'DE ACUERDO',
      examResultContent: '¡Felicidades! Tu puntuación es {value} y aprobaste el examen. Puedes consultar tu certificado ahora.'
    },
    startExam: {
      last: "Anterior",
      next: "siguiente",
      progress: "Progresos progresos",
      answerCard: "Tarjeta de respuesta",
      isFirst: "Ya es el primer tema",
      isLast: "Ya es el último tema",
      getSubjectFailed: "No lograron obtener el tema",
      confirmExit: "Confirmar salida?",
      startExam: "Inicio del examen",
      subject: "Número de materias",
      score: "Puntuación Total",
      tscore: 'Puntuación'
    },
    incorrect: {
      userName: "Nombre de usuario",
      score: "Puntuación Total",
      startTime: "Hora de inicio",
      endTime: "Tiempo final",
      duration: "Duración duración",
      correctNumber: "Conteo correcto",
      inCorrectNumber: "Conteo incorrecto",
      subjectList: "Lista de asuntos",
      userAnswer: "Su respuesta",
      answer: "Respuesta",
      analysis: "análisis",
      right: "derecho",
      wrong: "El mal",
      loadSubjectFailed: "No pudo obtener sujetos",
      operator: "Automáticamente clasificado por el sistema"
    },
    subject: {
      subjectTypeChoices: "SingleChoice",
      subjectTypeMultiChoices: "Multiopción",
      subjectTypeJudgement: "El juicio",
      subjectTypeShortAnswer: "ShortAnswer",
      subjectTypeFillBlank: "Rellenar",
      fillBlankAnswerPlaceholder:
        "Relleno múltiple las respuestas en blanco están separadas por saltos de línea"
    }
  },
  personal: {
    account: {
      identifier: "Cuenta cuenta",
      name: "Nombre",
      gender: "Género género",
      born: "Fecha de nacimiento",
      phone: "Teléfono teléfono",
      email: "Correo electrónico",
      avatar: "Avatar",
      inputIdentifier: "Por favor introduzca una cuenta",
      modifySuccess: "Modificado con éxito",
      modifyFailed: "Fallo en la modificación",
      avatarUploadSuccess: "Cargado con éxito el avatar",
      avatarUploadFailed: "No se pudo subir avatar",
      avatarUploadFormat: "Subir imágenes avatar sólo puede ser en formato JPG/PNG!",
      avatarUploadSize: "¡El tamaño de la imagen avatar subida no puede exceder los 2MB!"
    },
    pwd: {
      oldPwd: "Contraseña antigua",
      newPwd: "Nueva contraseña",
      confirmPwd: "Confirmar la nueva contraseña",
      inputNewPwd: "Introduzca una nueva contraseña",
      inputOldPwd: "Por favor, introduzca su contraseña antigua",
      pwdLenTips: "La contraseña no puede tener menos de 6 dígitos",
      inputPwdAgain: "Por favor, introduzca la contraseña de nuevo",
      pwdNotEqual: "¡Las dos contraseñas introducidas no coinciden!",
      modifySuccess: "Modificado con éxito",
      modifyFailed: "Fallo en la modificación"
    }
  },
  status: {
    examination: "examen",
    practice: "La práctica",
    questionnaire: "cuestionario",
    interview: "entrevista",
    complete: "Estadísticas terminadas",
    markComplete: "corregido",
    todoMark: "corregido",
    right: "Derecho",
    wrong: "El mal",
    men: "Hombres",
    women: "Mujeres"
  },
  media: {
    audio: {
      progress: "Barra de progreso:",
      limit: "Límite de reproducción alcanzado",
      playFailed: "Fallo al reproducir la voz",
      play: "Jugar",
      pause: "Pausa",
      muted: "En silencio",
      notMuted: "Jugar",
      transSpeed: "Avance rápido: x"
    },
    video: {
      playError:
        "Este video no se puede reproducir por el momento. Por favor intente de nuevo más tarde"
    }
  },
  searchForm: {
    document: 'Documentos',
    fileUnavailable: 'Este documento no tiene un enlace disponible',
    q: "Por favor introduzca la palabra clave",
    course: "curso",
    exam: "examen",
    other: "Los demás",
    searchSuccess: "El éxito de la búsqueda",
    searchFailed: "Fallo en la búsqueda",
    searchResult: "Find relevant results about",
    searchUnit: "a", // 个
    searchHistory: "Search history",
    allClear: "Clear all",
    searchTips: "You haven't searched yet",
    searchTop: "Top trending Searches"
  },
  becomeAPartner: {
    mainHeader: "Hazte instalador certificado de Sigenergy",
    subheading:
      "Únete a nosotros y conviértete en miembro de una comunidad que valora la transparencia, la calidad, el crecimiento y el apoyo mutuo."
  },
  becomeBPartner: {
    mainHeader: 'Become a Sigenergy Verified Distributor',
    subheading: 'Join us to become a member of a community that values transparency, quality, growth and mutual support.'
  },
  document: {
    documentType: "Tipo de documento",
    filterTag: "Etiqueta de filtro",
    all: "Todos",
    documentFile: "Hojas de datos",
    videoFile: "Manual de usuario",
    voiceFile: "Guías de instalación rápida",
    otherDocuments: "Certificados",
    brochure: "Folleto folleto",
    flyer: "Volante",
    image: "Imagen",
    video: "Video",
    download: "Descargar",
    center: "Centro de documentos",
    emptyResult: "No hay datos disponibles",
    plsSelectDocLang: 'Por favor seleccione el idioma del documento'
  },
  section: {
    filterTag: "Categoría de producto",
    catalogue: "Catálogo catálogo",
    trainingTag: 'Categoría deformación',
    total: "Total",
    chapters: "Capítulos",
    title: "Título",
    score: "LaPuntuación",
    points: "Las",
    viewsNumber: "Vistas",
    people: "LasPersonas",
    videoDuration: "Duración",
    minutes: "Minutos",
    collect: "Colec",
    upvote: "Upvote",
    startExamination: "Start the examination",
    startDate: "Start date",
    endDate: "End date"
  },
  notification: {
    contentTitle: "Contenido de la notificación título",
    first: "Inicio",
    contentTitleDetail: "detalles",
    contentAbstract: "Content",
    viewNum: "Number of views",
    commentsNum: "Number of comments",
    releaseDate: "Release date"
  },
  problem: {
    contentTitle: "Contenido del aviso título",
    first: "Inicio",
    contentTitleDetail: "detalles",
    contentAbstract: "Abstracto",
    viewNum: "vistas",
    commentsNum: "Comentarios",
    updateDate: "Fecha de actualización",
    commentsTitle: "Contenido de la evaluación",
    searchDefault: "Q&A",
    commentContent: "Añade un comentario",
    commentScore: "Evaluation total",
    previouspage: 'anterior',
    nextpage: 'próximo',
    commentUnit: "times"
  },
  warranty: {
    contentTitle: "Contenido de la evaluación",
    first: "Inicio",
    contentTitleDetail: "Detalles de las condiciones de garantía"
  },
  library: {
    quickLink: 'Enlace rápido',
    batchDownload: 'Descarga por lotes',
    category: 'Categoría',
    subCategory: 'Subcategorías',
    documentLanguage: 'Idioma del documento',
    downloadTip: 'Doble clic para descargar',
    filename: 'Nombre del archivo',
    maxLimit: 'Seleccione el número de archivos, con un máximo de no más de {value}',
    documentSearchKey: 'Por favor, introduzca la palabra clave del título del documento',
    allCategories:'Todas las categorías',
    currentCategory:'Buscar en la categoría actual: {value}',
    searchSuccess:'Búsqueda completada, palabras clave de búsqueda:',
    searchFailed:'La búsqueda falló, por favor inténtelo de nuevo.',
    downloading: 'Descargando...',
    cancelDownload: 'Cancelar',
    downloadCompleted: '¡Descarga completada exitosamente!',
    downloadFailed: 'Descarga fallida',
    downloadCancelled: 'Descarga cancelada'
  }
};
es.chooseFile = 'Seleccionar archivos'
es.select = 'Seleccionar'
es.library.enquiry = {
  dialogTitle: 'Consulta y Comentarios',
  basicInfo: 'Información básica',
  issueSection: 'Problema / Comentarios',
  additionalInfo: 'Información adicional',
  privacy: 'Declaración de privacidad',
  yourName: 'Su nombre',
  yourCompany: 'Su empresa',
  yourRole: 'Su rol',
  emailAddress: 'Correo electrónico',
  issueType: 'Tipo de problema',
  detailedDescription: 'Descripción detallada',
  upload: 'Carga de imágenes / archivos',
  uploadTip: 'Archivos múltiples, tamaño < {value}MB',
  privacyAgree: 'Acepto que la plataforma use esta información para el seguimiento.',
  roleDistributor: 'Distribuidor',
  roleInstaller: 'Instalador',
  roleGuests: 'Invitado',
  issueFeatureInquiry: 'Consulta de función',
  issueBugReport: 'Reporte de error',
  issueImprovement: 'Sugerencia de mejora',
  issueOther: 'Otro',
  btnSubmit: 'Enviar',
  btnCancel: 'Cancelar',
  msgSubmitSuccess: 'Enviado correctamente',
  msgSubmitFailed: 'Error al enviar',
  ruleRequired: 'Obligatorio',
  ruleInvalidEmail: 'Correo inválido',
  ruleAgreeRequired: 'Por favor, acepte la declaración de privacidad',
  ruleFileTooLarge: 'El archivo debe ser < {value}MB'
};
es.library.enquiry.uploadDesc = 'Código de error, captura de pantalla de la interfaz, documento, etc.'
es.library.enquiry.detailedDescriptionPlaceholder = 'Describa su problema, escenario de uso y mejora esperada'
es.library.enquiry.uploadSuccess = 'Subida exitosa'
es.library.enquiry.uploadFailed = 'Error al subir'
export default es;



// WEBPACK FOOTER //
// ./src/locales/lang/es/es.js